module.exports = __webpack_public_path__ + "img/2023-15.9e395a22.jpg";